import React, { useState, useEffect } from "react";
import {
    MAX_INT_VALUE,
    DEFAULT_FETCHED_OPTIONS,
    DEFAULT_PAGE,
    ACCESS_LEVEL,
} from "consts";
import { getProjects } from "api";
//
import {
    Grid,
    FormGroup,
    FormControl,
    FormControlLabel,
    Checkbox,
    Button,
} from "@material-ui/core";
//
import { ProjectAutoSuggest } from "containers/components/autoSuggest";

const ProjectPicker = (props) => {
    const [projects, setProjects] = useState([]);
    const { accessLevel, projectIds, onChange } = props;
    let projectListLastSelectedProject = null;

    useEffect(() => {
        fetchProjects(null, MAX_INT_VALUE).then((projects) => {
            setProjects(projects);
            if (props.selectAll) {
                selectAllProjects();
            } else {
                deselectAllProjects();
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectAll]);

    const fetchProjects = (q, pageSize, background) => {
        return getProjects(
            q,
            accessLevel,
            null,
            DEFAULT_PAGE,
            pageSize,
            null,
            null,
            background
        ).then((value) => value.content);
    };

    const sortSelectedProjects = (projects) => {
        const selectedProjects = projects.filter(project => projectIds.includes(project.Id));
        const unselectedProjects = projects.filter(project => !projectIds.includes(project.Id));
        return [...selectedProjects, ...unselectedProjects];
    };

    const areAllProjectsSelected = () => {
        const projectsAndSelectedProjectsIntersection = projects.filter(
            (project) => !projectIds.includes(project.Id)
        );

        return projectsAndSelectedProjectsIntersection.length === 0;
    };

    const isNoProjectSelected = () => props.projectIds.length === 0;

    const selectProjects = (projectIds) => onChange(projectIds);

    const deselectAllProjects = () => selectProjects([]);

    const selectAllProjects = () => selectProjects(projects.map((project) => project.Id));

    const onProjectSelectionChange = (e, project) => {
        const selectionIndex = projectIds.indexOf(project.Id);
        const isSelected = selectionIndex >= 0;

        const event = e.nativeEvent;
        if (event.shiftKey && projectListLastSelectedProject) {
            const lastSelectedProjectIndex = projects.indexOf(projectListLastSelectedProject);
            const index = projects.indexOf(project);

            const from = Math.min(lastSelectedProjectIndex, index);
            const to = Math.max(lastSelectedProjectIndex, index);

            let allSelected = true;
            for (let i = from; i <= to; i++) {
                if (i === lastSelectedProjectIndex) {
                    // last clicked project
                    continue;
                }

                if (!projectIds.includes(projects[i].Id)) {
                    allSelected = false;
                    break;
                }
            }

            if (allSelected) {
                for (let i = from; i <= to; i++) {
                    const isProjectSelected = projectIds.includes(projects[i].Id);
                    if (isProjectSelected) {
                        projectIds.splice(selectionIndex, 1);
                    }
                }
            } else {
                for (let i = from; i <= to; i++) {
                    projectIds.push(projects[i].Id);
                }
            }
        } else if (e.target.checked ^ isSelected) {
            if (e.target.checked) {
                projectIds.push(project.Id);
            } else {
                projectIds.splice(selectionIndex, 1);
            }
        }

        projectListLastSelectedProject = project;

        const projectIdsDistinct = projectIds.filter((item, pos, array) => array.indexOf(item) === pos);
        selectProjects(projectIdsDistinct);
    };

    return (
        <Grid container direction="column" spacing={3} className="picker-container">
            <Grid container item>
                <Grid item xs={12}>
                    <ProjectAutoSuggest
                        label="Projects"
                        value={null}
                        fetchOptions={(q) => fetchProjects(q, DEFAULT_FETCHED_OPTIONS, true)}
                        onChange={(project) => {
                            if (!project) {
                                return;
                            }

                            const containsProject = projectIds.includes(project.Id);
                            if (!containsProject) {
                                const newProjectIds =  [...projectIds];
                                newProjectIds.push(project.Id);
                                onChange(newProjectIds);
                            }
                        }}
                        error={props.error}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormGroup className="item-list">
                        {sortSelectedProjects(projects).map((project) =>
                            <FormControl key={project.Id} style={{ width: "100%" }}>
                                <FormControlLabel
                                    value={project.Name}
                                    label={project.Name}
                                    labelPlacement="end"
                                    className={
                                        projectListLastSelectedProject === project
                                            ? "item--selected"
                                            : ""
                                    }
                                    control={
                                        <Checkbox
                                            onChange={(e) => onProjectSelectionChange(e, project)}
                                            checked={projectIds.includes(project.Id)}
                                        />
                                    }
                                />
                            </FormControl>
                        )}
                    </FormGroup>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={3} justifyContent="flex-end">
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => selectAllProjects()}
                            disabled={areAllProjectsSelected()}
                        >
                            SELECT ALL
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => deselectAllProjects()}
                            disabled={isNoProjectSelected()}
                        >
                            DESELECT ALL
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

ProjectPicker.defaultProps = {
    accessLevel: ACCESS_LEVEL.REPORTS,
};

export default ProjectPicker;
